export default __webpack_public_path__ + "static/media/file-addition.ecf104e7.svg";